export default __webpack_public_path__ + "static/media/honesty_intro.2bf3a908.png";